var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeechBubble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "speech-bubble_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4963",
  fill: "currentColor",
  d: "M0 0h24v22H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33346",
  clipPath: "url(#speech-bubble_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13089",
  d: "M12 0C5.384 0 0 4.428 0 9.87a8.8 8.8 0 0 0 2.339 5.865l-.757 5.055a1.075 1.075 0 0 0 .359.978.971.971 0 0 0 .629.232.947.947 0 0 0 .36-.07l6.15-2.484a14.457 14.457 0 0 0 2.92.294c6.617 0 12-4.428 12-9.87S18.617 0 12 0m0 17.645a12.549 12.549 0 0 1-2.792-.311.959.959 0 0 0-.573.046l-4.809 1.942.567-3.785a1.076 1.076 0 0 0-.3-.919A6.685 6.685 0 0 1 2 9.87C2 5.583 6.486 2.1 12 2.1s10 3.483 10 7.77-4.486 7.775-10 7.775",
  fill: "currentColor"
}))));
export default SvgSpeechBubble;